import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NbDialogService, NbIconModule, NB_WINDOW } from '@nebular/theme';

import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LOGIN_URL_PROFESSIONAL } from 'docs/app/app.paths';

@Component({
    selector: 'ngd-hero',
    styleUrls: ['./hero.component.scss'],
    template: `
    <div class="block">
      <h1 style="margin-bottom: 0.2em">Santea</h1> 
      <h2 style="margin-top: 0px">{{'hhPlatform.home.hero.practice' | translate }}</h2>
      <p class="hero-promo">
        {{'hhPlatform.home.hero.description' | translate }}
      </p>
      <div class="btns-wrapper">
        <!-- <a class="btn get-started" routerLink="docs">{{'hhPlatform.home.hero.tryit' | translate}}</a> -->
        <a class="btn" id=downloadButton  routerLink="/userLogin/">{{'hhPlatform.home.hero.login' | translate}}</a>
        <button (click)="redirectToSignup()" class="btn download">{{'hhPlatform.home.hero.register' | translate}}</button>
      </div>
      <div class="hero-features">
        <div class="hero-feature">
          <div class="feature-key">
            40+
          </div>
          <h3 class="feature-title">
            {{ 'hhPlatform.home.hero.billing' | translate}}
          </h3>
        </div>
        <div class="hero-feature">
          <div class="feature-key">
            4
          </div>
          <h3 class="feature-title">
            {{ 'hhPlatform.home.hero.standards' | translate}}
          </h3>
        </div>
        <div class="hero-feature">
          <div class="feature-key">
            3
          </div>
          <h3 class="feature-title">
            {{ 'hhPlatform.home.hero.loginMethods' | translate}}
          </h3>
        </div>
        <div class="hero-feature">
          <div class="feature-key">
            <nb-icon icon="lock"></nb-icon>
          </div>
          <h3 class="feature-title">
            {{'hhPlatform.home.hero.luxTrust' | translate}}
          </h3>
        </div>
      </div>
    </div>
    <div class="right-block">
      <div class="hero-components">
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, NbIconModule, TranslateModule],
})
export class NgdHeroComponent {

  private window: Window;

  constructor(
    @Inject(NB_WINDOW) window: Window,
    private dialogService: NbDialogService,
    public translate: TranslateService
  ) {
    this.window = window;
  }

  // showDownloadDialog(): void {
  //   const context = {
  //     title: 'Download',
  //     formConfig: {
  //       portalId: 'XXXXXXX',
  //       formId: 'some-form-id',
  //       redirectUrl: '',
  //     },
  //   };

  //   this.dialogService.open(NgdHubspotFormDialogComponent, { context });
  // }
    redirectToSignup() {
      this.window.location.href = LOGIN_URL_PROFESSIONAL;
    }
}
